import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditMenuLayer from "../../components/restaurants/EditMenuLayer";


const EditMenuPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Edit Menu" />

        {/* AddUserLayer */}
        <EditMenuLayer />


      </MasterLayout>
    </>
  );
};

export default EditMenuPage;
